import React from 'react';
import { Theme, Typography, Button } from '@mui/material';
import { createStyles, withStyles, WithStyles } from '@mui/styles';

import { withTranslation, WithTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';

import StoreModel from '../../models/Index';
import { Services } from '../../helpers/constants/Services';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RoutePaths } from 'helpers/constants/RoutePaths';

interface LanguageSelectProps
    extends RouteComponentProps,
    WithStyles<typeof styles>,
    WithTranslation { }
interface LanguageSelectPropsInjected extends LanguageSelectProps {
    Store: StoreModel;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: "10vh 10% 15vh 10%",
            height: '90vh',
        },
        button: {
            width: '480px',
            height: '104px',
        },
        logoContainer: {
            height: '25vh',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            display:'flex',
            flexDirection: 'column',
        },
        logo: {
            maxHeight: '25vh',

        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: "10vh 0 0",
            height: '30vh'
        },
    });

@inject(Services.STORE)
@observer
class LanguageSelect extends React.Component<LanguageSelectProps, any> {
    get injected() {
        return this.props as LanguageSelectPropsInjected;
    }

    componentDidMount() {
        // const { Store } = this.injected;
        // Store.reset();
    }

    render() {
        const { classes } = this.props;
        const { Store } = this.injected;

        const logoUrl = Store.kioskLogo;

        return (
            <div className={classes.root}>
                <div className={classes.logoContainer}>
                    <img src={logoUrl} alt={'Logo'} className={classes.logo} />
                </div>
                <div className={classes.container}>
                    <Button
                        className={classes.button}
                        style={{ marginBottom: '64px' }}
                        variant='primary'
                        onClick={(_) => this.setLanguage('en')}
                    >
                        <Typography
                            variant='button'
                            style={{ fontSize: '2.25rem' }}
                        >
                            English
                        </Typography>
                    </Button>
                    <Button
                        className={classes.button}
                        variant='primary'
                        onClick={(_) => this.setLanguage('es')}
                    >
                        <Typography
                            variant='button'
                            style={{ fontSize: '2.25rem' }}
                        >
                            Español
                        </Typography>
                    </Button>
                </div>
            </div>
        );
    }

    setLanguage(lang: string) {
        const { history, location } = this.props;
        const { Store } = this.injected;

        Store.setLang(lang).then((_) => {
            if (Store.isOutOfOrder) {
                history.push({
                    pathname: RoutePaths.KioskOutOfOrder,
                    search: location.search,
                });
            }

            history.push({
                pathname: RoutePaths.ApplicationSelect,
                search: location.search,
            });
        });
    }
}

export default withTranslation()(
    withStyles(styles)(withRouter(LanguageSelect))
);
